export default __webpack_public_path__ + "static/media/SnowLeopard_Transparent.54e6b58d.png";